import React, { useContext } from 'react';
import { Select, MenuItem, Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DataContext } from '../contexts/DataContext';

const languages = [
  { code: 'en', flag: 'en.png' },
  { code: 'de', flag: 'de.png' },
  { code: 'fr', flag: 'fr.png' },
];

export const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const { data, setData, trackEvent } = useContext(DataContext);

  const [selectedLanguage, setSelectedLanguage] = React.useState(
    ['de', 'en', 'fr']?.includes(localStorage.getItem('i18nextLng'))
      ? i18n.language
      : 'en'
  );

  const handleLanguageChange = (event) => {
    setSelectedLanguage(event.target.value);
    i18n.changeLanguage(event.target.value);
    setData({ ...data, language: event.target.value });
    trackEvent({ language_change: 1 });
  };

  return (
    <div
      style={{
        // border:'1px solid #44546A',

        cursor: 'pointer',
        width: '76px',
        borderRadius: '8px',
        height: '36px',
        background: 'white',
      }}
    >
      <Select
        value={selectedLanguage}
        onChange={handleLanguageChange}
        displayEmpty={false}
        native={false}
        IconComponent={() => (
          <div
            style={{ width: '10px', marginLeft: '-35px', marginTop: '-5px' }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="10"
              height="7"
              viewBox="0 0 10 7"
              fill="none"
            >
              <path d="M1 1L5 5L9 1" stroke="#9CA0AB" stroke-width="2" />
            </svg>
          </div>
        )}
        MenuProps={{
          getContentAnchorEl: null, // Fixes positioning issues on mobile

          disablePortal: true,
          sx: {
            /*border:'none',
          outline:"none",
          '&:hover': {
            borderColor: 'transparent',
             border:'none',
            outline:"none",
            background:"red"
          },*/
          },
          MenuListProps: {
            sx: {
              paddingTop: '4px',
              background: 'transparent',
              /* outline: 'none',
            border: 'none',
            '&:hover': {
              border: 'none',
              outline: 'none',
            },*/
            },
          },
          PaperProps: {
            sx: {
              background: 'transparent',
              boxShadow: 'none',
              // maxHeight: '80px',
            },
          },
        }}
        inputProps={{
          sx: {
            padding: '0',
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              //border: '1px solid #E6E6E6',
            },
            /* border: 'none',
          outline: 'none',
          
          '&:hover': {
            border: 'none',
            outline: 'none',
          },*/
          },
        }}
        sx={{
          cursor: 'pointer',
          width: '76px',
          padding: '8px',
          borderRadius: '8px',
          height: '36px',
          background: 'white',

          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: '1px solid #E6E6E6',
          },
          /*  border:'none',
          outline:"none",
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          border: 'none',
          outline: 'none',
        },
        '&:hover': {
          borderColor: 'transparent',
           border:'none',
          outline:"none"
        },*/
        }}
      >
        {languages.map((lang, i) => (
          <MenuItem
            key={lang.code}
            value={lang.code}
            native={false}
            sx={{
              height: '36px',
              minHeight: '36px !important',
              borderRadius: '8px',
              width: '76px',
              background: 'white',
              padding: '0px',
              paddingInline: '8px',
              maxHeight: '36px',

              borderBottom:
                i !== languages?.length - 1 ? '1px solid #F6F4F0' : '',
              '&.Mui-selected': {
                background: 'white',
                '&:hover': {
                  background: '#F6F4F0',
                },
              },
              '& .MuiButtonBase-root': {
                maxHeight: '20px',
              },
              '&:hover': {
                background: '#F6F4F0',
              },
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              sx={{ gap: '5px', width: '40px' }}
            >
              <img
                src={lang.flag}
                alt={lang.code}
                style={{
                  width: '15px',
                  height: '15px',
                  borderRadius: '50%',
                  objectFit: 'contain',
                }}
              />
              <Typography
                sx={{
                  fontSize: '14px',
                  fontWeight: '600',
                  color: '#44546A',
                  lineHeight: '21px',
                  textTransform: 'uppercase',
                }}
              >
                {lang.code}
              </Typography>
            </Box>
          </MenuItem>
        ))}
      </Select>
    </div>
  );
};

export default LanguageSelector;
